// extracted by mini-css-extract-plugin
export default {"customers_and_wizard_steps-mini":"styles_customers_and_wizard_steps-mini__F5TBh","title-mini":"styles_title-mini__oRrcA"};